import { useCallback, useState } from "react";

import { useGlobalContext } from "../Context/GlobalContext";
import { useCatalogue } from "./useCatalogue";
export const useRestaurantDetails = () => {
  const { api } = useGlobalContext();

  const { getCatalogItems } = useCatalogue();

  const [restaurantDetails, setRestaurantDetails] = useState(null);
  const [restaurantDetailsLoading, setRestaurantDetailsLoading] =
    useState(false);
  const [restaurantDetailsError, setRestaurantDetailsError] = useState("");

  const getRestaurantDetails = useCallback(
    async ({ user_id }) => {
      const cleanUserId = String(user_id || "").trim();

      if (!cleanUserId) {
        const message = "Restaurant user id is missing.";

        setRestaurantDetails(null);
        setRestaurantDetailsError(message);

        return {
          success: false,
          data: null,
          message,
        };
      }

      try {
        setRestaurantDetailsLoading(true);
        setRestaurantDetailsError("");

        const payload = {
          user_id: cleanUserId,
        };

        console.log("GET RESTAURANT DETAILS PAYLOAD:", payload);

        const response = await api.post(
          "/Chaafo/getRestaurantDetails",
          payload,
        );

        console.log("GET RESTAURANT DETAILS RESPONSE:", response?.data);

        const responseData = response?.data;

        if (String(responseData?.responseCode) !== "00") {
          const message =
            responseData?.responseMessage ||
            "Unable to fetch restaurant details.";

          setRestaurantDetails(null);
          setRestaurantDetailsError(message);

          return {
            success: false,
            data: null,
            message,
          };
        }

        let details = Array.isArray(responseData?.response)
          ? responseData.response[0] || null
          : responseData?.response || null;

        // =====================================================
        // ADDRESS FROM RESTAURANT DETAILS API
        // =====================================================

        const primaryAddress = String(
          details?.address || details?.restaurant_address || "",
        ).trim();

        // =====================================================
        // FALLBACK ADDRESS FROM CATALOGUE API
        // =====================================================

        if (!primaryAddress && cleanUserId) {
          try {
            const catalogueResult = await getCatalogItems({
              userid: cleanUserId,
              orderType: "takeaway",
              platform: "",
              bestFor: "",
            });

            if (catalogueResult?.success) {
              const catalogueRestaurant =
                catalogueResult?.restaurantDetails || {};

              const catalogueAddress = String(
                catalogueRestaurant?.address ||
                  catalogueRestaurant?.restaurant_address ||
                  catalogueRestaurant?.street ||
                  "",
              ).trim();

              const city = String(catalogueRestaurant?.city || "").trim();

              const state = String(catalogueRestaurant?.state || "").trim();

              const pincode = String(
                catalogueRestaurant?.pincode ||
                  catalogueRestaurant?.pin_code ||
                  catalogueRestaurant?.postal_code ||
                  "",
              ).trim();

              const completeCatalogueAddress =
                catalogueAddress ||
                [city, state, pincode].filter(Boolean).join(", ");

              if (completeCatalogueAddress) {
                details = {
                  ...details,
                  address: completeCatalogueAddress,
                };
              }
            }
          } catch (catalogueError) {
            console.error("Catalogue address fallback error:", catalogueError);
          }
        }

        setRestaurantDetails(details);

        return {
          success: true,
          data: details,
          message: responseData?.responseMessage || "",
        };
      } catch (error) {
        console.error(
          "getRestaurantDetails API error:",
          error?.response?.data || error,
        );

        const message =
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          error?.message ||
          "Unable to fetch restaurant details.";

        setRestaurantDetails(null);
        setRestaurantDetailsError(message);

        return {
          success: false,
          data: null,
          message,
        };
      } finally {
        setRestaurantDetailsLoading(false);
      }
    },
    [api, getCatalogItems],
  );

  return {
    restaurantDetails,
    restaurantDetailsLoading,
    restaurantDetailsError,
    getRestaurantDetails,
  };
};
